// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"c64d2f3e","732":"9a0c6702"}[chunkId] + ".chunk.js";
};